import { useCallback } from "react";
import { axiosBeyonClient } from "utils/beyonAuth/beyonAxiosClient";
import { useWorkspace } from "../useWorkspace";
import { SasResponse } from "./useReadSas";

type DownloadFilesProps = {
    fileIds: string[],
    onError?: (error: string) => void
}

export default function useDownloadFile(workspaceId: string) {

    const workspace = useWorkspace(workspaceId);
    const apiEndpoint = workspace.data?.config?.filestoreConfig?.apiEndpoint;

    const donwloadFilesMemo = useCallback(async ({ fileIds, onError }: DownloadFilesProps) => {

        fileIds.forEach(async fileId => {

            const url = `${apiEndpoint}/file/${fileId}/sas`;

            const sasRequest = await axiosBeyonClient.get<SasResponse>(url);

            if (!(sasRequest.status === 200 || sasRequest.status === 201)) {
                onError(sasRequest.statusText);
            }

            const iframe = document.createElement('iframe');
            iframe.src = sasRequest.data.sasUri;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 10000);
        });
    }
        , [apiEndpoint]);

    return { downloadFiles: donwloadFilesMemo };
}
